export const CHARACTER_CATEGORIES = {
  SPECIAL_CHARACTER: 'special_character',
  UPPER_CASE_LETTER: 'upper_case_letter',
  LOWER_CASE_LETTER: 'lower_case_letter',
  NUMBER: 'number',
  MINIMUM_LENGTH: 'minimum_length'
};